import { Alert } from "@kyan/ui";

import { useAppNoticeController } from "./AppNotice.controller";

export const AppNotice = () => {
  const { title, description, isInvisible, handleClick } =
    useAppNoticeController();

  if (isInvisible) return null;

  return (
    <Alert
      title={title}
      className="p-4"
      variant="notice"
      description={description}
      actionProps={{
        size: "md",
        children: "Read more",
        variant: "alternative",
        className: "text-sm w-26",
        onClick: handleClick,
      }}
    />
  );
};
